export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14679.4fc849f4.jpg";